export default "__VITE_ASSET__BN5hbyTK__"